/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".upload-section[_ngcontent-%COMP%]{width:103%;height:350px;background:#efefef;margin-top:-32px;margin-left:-16px;margin-bottom:-32px;text-align:center;padding-top:86px;cursor:pointer}.upload-section[_ngcontent-%COMP%]   .file[_ngcontent-%COMP%]{display:none}.upload-section[_ngcontent-%COMP%]   .cloud[_ngcontent-%COMP%]{background:url(/assets/images/upload-cloud.png) center/contain no-repeat;width:200px;height:100px;margin:0 auto 15px;opacity:.4}.upload-section[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{opacity:.4}"];
export { styles as styles };
